import React from 'react'
import AddButton from '../../atoms/AddButton/AddButton'
import EmployeeSelect from '../../atoms/EmployeeSelect/EmployeeSelect'

const EMPTY_EXTRA_OPTIONS = [];

const PageContainerHeader = ({
    title,
    button,
    buttonTitle,
    onclickDrawer,
    rightContent = null,
    selection = false,
    onSelectEmployee = () => { },
    selectValue,
    defaultSelectValue = null,
    onClearSelection = null,
    employeeSelectExtraOptions = EMPTY_EXTRA_OPTIONS,
    employeeSelectStaticOptions = null,
    employeeSelectOptionsLoading = false,
    employeeSelectExcludeCeoCmo = true,
    employeeSelectIncludeExEmployees = false,
    employeeSelectAllowClear = true,
}) => {
    const hasActiveSelectionFilter =
        selection &&
        defaultSelectValue != null &&
        selectValue != null &&
        String(selectValue) !== String(defaultSelectValue);

    const handleClearSelection = () => {
        if (typeof onClearSelection === "function") {
            onClearSelection();
            return;
        }
        onSelectEmployee(defaultSelectValue);
    };

    return (
        <div className='card-border card-body mb-4 page-container-header'>
            <div className='flex items-center justify-between gap-3 page-container-header-row'>
                <div className='text-xl font-semibold text-sky-900'>{title}</div>
                <div className="flex items-center gap-2">
                    {button && <AddButton buttonTitle={buttonTitle} onclickDrawer={onclickDrawer} image='/svg/PlusIcon.svg' />}
                    {rightContent}
                    {selection && (
                        <>
                            <EmployeeSelect
                                value={selectValue}
                                onSelectEmployee={onSelectEmployee}
                                extraOptions={employeeSelectExtraOptions}
                                staticOptions={employeeSelectStaticOptions}
                                optionsLoading={employeeSelectOptionsLoading}
                                excludeCeoCmo={employeeSelectExcludeCeoCmo}
                                includeExEmployees={employeeSelectIncludeExEmployees}
                                allowClear={employeeSelectAllowClear}
                            />
                            {hasActiveSelectionFilter ? (
                                <button
                                    type="button"
                                    className="page-container-header__clear-filter text-xs text-[#3867d6]"
                                    onClick={handleClearSelection}
                                >
                                    Clear filter
                                </button>
                            ) : null}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PageContainerHeader
